import main from './main/routes/dynamic';
import common from './common/routes/dynamic';

const modules = [main, common];
const moduleRoutes = modules
  .map(Object.values)
  .reduce((prev, current) => prev.concat(current), []);

export default moduleRoutes;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/routes-dynamic.js